module.exports = __webpack_public_path__ + "img/upi1.bf8467d8.png";